import { render, staticRenderFns } from "./CoachDetails.vue?vue&type=template&id=76f48edd&"
import script from "./CoachDetails.vue?vue&type=script&lang=js&"
export * from "./CoachDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports